<template>
  <div>
    <v-layout row wrap class="pt-4 pb-1">
      <v-flex xs12 sm8 :class="{'pb-0': isMobile}">
        <v-autocomplete
          v-model="selectedStudent"
          dense
          label="Select Student"
          placeholder="Enter Student"
          :items="studentsArray"
          :clearable="true"
          :error-messages="studentSearchError"
          :return-object="true"
          :search-input.sync="studentSearchInput"
          item-text="firstName"
          item-value="studentId"
          :loading="studentSearchLoading"
          :no-filter="true"
          @focus="clearStudentAutoComplete">
          <!--this is how the data in the select appears-->
          <template slot="item" slot-scope="{item, tile}">
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="primary--text">
                  {{item.firstName}} {{item.lastName}}
                  <span class="pl-1">{{item.studentExtId}}</span>
                </span>
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{item.schoolName}}
                <span class="pl-1">Grade: {{item.grade}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
          <template slot="selection" slot-scope="{item, selected}">
            <v-list-tile-content>
              <v-list-tile-title>
                {{item.firstName}} {{item.lastName}}
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
          <!--message that displays when search matches nothing-->
          <template slot="no-data">
            <v-list>
              <!--message when no input is entered-->
              <v-list-tile v-if="!studentSearchInput">
                Please type a Student.
              </v-list-tile>
              <!--message when no provider matches text-->
              <v-list-tile v-if="studentSearchInput && !studentSearchLoading">
                No Results
              </v-list-tile>
            </v-list>
          </template>
        </v-autocomplete>
      </v-flex>
      <!--retrieve student details button-->
      <v-flex xs12 sm4 :class="{'pt-0': isMobile}">
        <v-tooltip :disabled="!showTooltip" top>
          <v-btn
            class="retrieve-students-button"
            color="primary"
            slot="activator"
            :disabled="!selectedStudent"
            block
            @click="onRetrieveStudentDetailsClicked">
            Retrieve Student Details
          </v-btn>
          <span>Display services and providers for selected student</span>
        </v-tooltip>
      </v-flex>
      <!--student details-->
      <v-flex xs12 mb-5>
        <div v-if="!studentServices" class="font-italic primary--text">
          No students.  Use the Select Student Search above to find a student,
          then click on "Retrieve Student Details"
        </div>
        <div v-else>
          <v-card class="student-details-card">
            <!--CARD TITLE AND SUBTITLE (STUDENT INFORMATION)-->
            <v-card-title>
              <div class="white--text">
                <!--if the student has been selected-->
                <template>
                  <!--STUDENT NAME AND STUDENT NUMBER-->
                  <div class="title">
                    {{studentServices[0].firstName}} {{studentServices[0].lastName}}
                    <v-tooltip :disabled="!showTooltip" top>
                    <span slot="activator">
                      ({{studentServices[0].studentExtId}})
                    </span>
                      <span>Student ID</span>
                    </v-tooltip>
                  </div>
                  <!--SUBTITLE WITH SCHOOL INFORMATION-->
                  <span>
                <!--gender-->
                  <v-tooltip :disabled="!showTooltip" top>
                    <span slot="activator" class="pr-1">
                      {{studentServices[0].gender}}
                    </span>
                    <span>Gender</span>
                  </v-tooltip>
                  <span class="pr-1"><strong>Gr: {{studentServices[0].grade}}</strong></span>
                  <span clas="pr-1">
                    {{studentServices[0].schoolName}}
                    <v-tooltip :disabled="!showTooltip" top>
                      <span slot="activator">
                        ({{studentServices[0].schoolCode}})
                      </span>
                      <span>Student's School Code</span>
                    </v-tooltip>
                  </span>
                </span>
                </template>
              </div>
            </v-card-title>
          </v-card>
          <v-card class="mt-3 student-services-card">
            <!--student services-->
            <v-card-text class="pa-0">
<!--              TODO - Move error alert-->
              <v-alert :value="errorMsg" type="error">{{errorMsg}}</v-alert>
              <!--EXPANSION PANEL-->
              <v-expansion-panel
                v-if="studentServices"
                v-model="panel"
                class="student-services-expansion-panel">
                <v-expansion-panel-content
                  v-for="(service, index) in studentServices" :key="index">
                  <div
                    slot="header"
                    :class="{ 'warning--text': !service.active,
                              'primary--text': service.active }">
                    <!--student services-->
                    <template>
                      <div class="font-weight-bold">
                        <v-tooltip :disabled="!showTooltip" top>
                          <span slot="activator">
                            {{service.planTypeName}}: {{service.serviceType}}
                          </span>
                          <span>Plan Type/Service</span>
                        </v-tooltip>
                        <span class="pl-2">
                          ESY: <span v-if="service.esy">Yes</span><span v-else>No</span>
                        </span>
                        <span
                          class="float-right"
                          :class="{ 'pr-3': !isMobile, 'secondary--text': service.active }">
                          {{ service.active ? 'Active' : 'Inactive' }}
                        </span>
                      </div>
                      <div class="font-weight-bold">
                        <v-tooltip :disabled="!showTooltip" top>
                          <span slot="activator">
                            {{service.startDate | formatDate}} -
                            {{service.endDate | formatDate}}
                          </span>
                          <span>Projected Start/End Dates</span>
                        </v-tooltip>
                        <v-tooltip :disabled="!showTooltip" top>
                        <span slot="activator">
                          <span v-if="isMobile"><br></span>
                          <span :class="{'pl-2': !isMobile}">{{service.frequency}}</span>
                        </span>
                          <span>Service Frequency</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </div>
                  <v-card class="expanded-card">
                    <!--add new provider autocomplete-->
                    <provider-autocomplete
                      :service="service"
                      :showTooltip="showTooltip"
                      :isMobile="isMobile"
                      v-on:update-services="updateStudentServices">
                    </provider-autocomplete>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
    <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
  </div>
</template>

<script>
import api from '@/utils/api';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import * as Constants from '@/constants';
import ProviderAutocomplete from './add-new-provider-autocomplete';

export default {
  name: 'StudentAdd',
  components: {
    FullScreenLoadingSpinner,
    ProviderAutocomplete
  },
  props: ['showTooltip'],
  data() {
    return {
      selectedStudent: null,
      selectedStudentCopy: null,
      // select student autocomplete
      studentSearchError: '',
      studentSearchInput: null,
      studentSearchLoading: false,
      studentsArray: [],
      // app loading screen
      showLoading: false,
      errorMsg: null,
      studentServices: null,
      studentsList: null,
      panel: [true],
      addNewProvider: false,
      newProvider: '',
      serviceId: null
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  },
  methods: {
    clearStudentAutoComplete() {
      if (!this.selectedStudent) {
        this.studentsArray = [];
      }
    },
    onRetrieveStudentDetailsClicked() {
      this.errorMsg = null;
      this.studentServices = null;
      this.showLoading = true;
      api.get(Constants.GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(this.selectedStudentCopy.studentId))
        .then((res) => {
          if (!res.data.data.length) throw new Error('Student does not have any eligible services.');
          this.showLoading = false;
          this.studentServices = res.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.selectedStudent = null;
          this.showLoading = false;
        });
    },
    updateStudentServices() {
      this.errorMsg = null;
      this.showLoading = true;
      api.get(Constants.GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(this.selectedStudentCopy.studentId))
        .then((res) => {
          if (res.data.status !== 'success') throw new Error('Something went wrong.')
          this.studentServices = res.data.data;
          this.showLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    }
  },
  watch: {
    // fires the api call to get student list
    studentSearchInput() {
      // show loading
      this.studentSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.studentSearchInput.length >= 2) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.GET_SCHEDULER_STUDENT_LIST_URL(this.studentSearchInput))
            .then((res) => {
              this.studentsArray = res.data.data;
            })
            .catch((error) => {
              this.studentSearchError = error.message;
            })
            .finally(() => {
              this.studentSearchLoading = false;
            });
        }, 300);
      } else {
        this.studentSearchLoading = false;
      }
    },
    // watcher on selectedStudent to clear the value when clicking on the X
    selectedStudent(newVal, oldVal) {
      if (newVal) this.selectedStudentCopy = newVal;
      if (!newVal && oldVal) this.studentsArray = [];
    }
  }
};
</script>

<style lang="scss" scoped>
  .retrieve-students-button {
    height: 47px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) !important;
  }

  .student-details-card {
    border-radius: 10px;
    .v-card__title {
      background-color: var(--v-primary-base);
    }
  }

  .student-services-card {
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    .student-services-expansion-panel {
      border-radius: 10px;
      box-shadow: none;
      .v-expansion-panel__container:first-child {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .v-expansion-panel__container:last-child {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .expanded-card {
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
      }
      .expanded-card {
        border-top: 1px solid var(--v-primary-base);
      }
    }
  }

  .mt-50 {
    margin-top: 50px;
  }

  .padding-right {
    padding-right: 3px;
  }

  .icon-padding {
    padding-right: 10px;
  }

  .actionButton-tablet {
    width: 105px;
  }

  .studentInfo {
    font-size: 1.2em;
    padding: 10px;
  }

  .small {
    font-size: 80%;
  }

  .mobile-padding {
    padding-left: 3px;
    padding-right: 3px;
  }

  .table-padding {
    padding-left: 25px;
    margin-top: 10px;
  }

  .border-bottom {
    border-bottom: 1px solid black;
  }

  .add-new-provider {
    width: 100%;
    height: 70%;
    border-bottom: 1px solid black;
    padding: 5px;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/scheduler/add-by-student.vue